import React from 'react';
import { Col } from '../../bootstrap/index.jsx';
import Select from '../../common/Select.jsx';
import TextInput from '../../common/TextInput';
import {update} from '../../../helpers';

//const AGGREGATE_OPTIONS = ['max', 'min'].map(a => ({value: a, label: a}));

const ComputedMatchColumnType = (
  {
    accessor,
    values,
    columns,
    setValues
  }) => {

  const allColumns =
    columns.filter(c => c.field != accessor).map(c =>({value: c.field, label: c.headerName}));

  const aggregationColumns =
    columns.filter(c => c.filter == 'agNumberColumnFilter' && c.field != accessor && c.field != values.group_by).map(c => ({value: c.field, label: c.headerName}));

  const handleComputedMatchSettingsChange = (attr, val) => {
    let updatedSettings = update(values, {[attr]: {$set: val}});
    setValues(prev => ({...prev, ['computed_match_settings']: updatedSettings}));
  };

  return <>
    <Col size='xs-12' className='mt-1'>
      <label>{I18n.t('select_column_for_grouping')}</label>
      <Select
        defaultValue={values.group_by}
        options={allColumns}
        onChange={(val) => handleComputedMatchSettingsChange('group_by', val)}
      />
    </Col>
    {/* <Col size='xs-6' className='mt-1'>
      <label>{I18n.t('aggregation_filter')}</label>
      <Select
        defaultValue={values.agg_filter}
        options={AGGREGATE_OPTIONS}
        onChange={(val) => handleComputedMatchSettingsChange('agg_filter', val)}
      />
    </Col>*/}
    <Col size='xs-12' className='mt-1'>
      <label>{I18n.t('aggregation_filter_max')}</label>
      <Select
        defaultValue={values.agg_filter_col}
        options={aggregationColumns}
        onChange={(val) => handleComputedMatchSettingsChange('agg_filter_col', val)}
      />
    </Col>
    <Col size='xs-6' className='mt-1'>
      <label>{I18n.t('label_when_value_matches')}</label>
      <TextInput value={values.match_label} onChange={(e) => handleComputedMatchSettingsChange('match_label', e.target.value)} />
    </Col>
    <Col size='xs-6' className='mt-1'>
      <label>{I18n.t('label_when_value_doesnt_match')}</label>
      <TextInput value={values.mismatch_label} onChange={(e) => handleComputedMatchSettingsChange('mismatch_label', e.target.value)} />
    </Col>
  </>
}

export default ComputedMatchColumnType;